import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'outline' | 'quiet';
type Size = 'md' | 'lg';
interface BaseProps {
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  className?: string;
}
const base = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-sm font-sans font-medium transition-[background-color,color,border-color,box-shadow,transform] duration-200 ease-out-quint active:translate-y-px disabled:cursor-not-allowed disabled:opacity-60';
const variants: Record<Variant, string> = {
  primary: 'bg-gold text-cream hover:bg-gold-dark shadow-[0_1px_0_rgba(31,29,26,0.12)]',
  outline: 'border border-charcoal/25 text-charcoal hover:border-charcoal hover:bg-charcoal/[0.04]',
  quiet: 'text-gold-dark hover:text-charcoal'
};
const sizes: Record<Size, string> = {
  md: 'h-10 px-4 text-sm',
  lg: 'h-12 px-6 text-[0.95rem]'
};
function classes(variant: Variant, size: Size, className?: string) {
  const sizing = variant === 'quiet' ? 'text-sm' : sizes[size];
  return [base, variants[variant], sizing, className].filter(Boolean).join(' ');
}
interface LinkButtonProps extends BaseProps {
  to: string;
}
export function LinkButton({
  to,
  children,
  variant = 'primary',
  size = 'md',
  className
}: LinkButtonProps) {
  return <Link to={to} className={classes(variant, size, className)} data-id="element-23" data-mp="8agxz5zbc2dj">
      {children}
    </Link>;
}
interface ButtonProps extends BaseProps, React.ButtonHTMLAttributes<HTMLButtonElement> {}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className,
  ...rest
}: ButtonProps) {
  return <button {...rest} className={classes(variant, size, className)} data-id="element-24" data-mp="3gip64c8nmm1s">
      {children}
    </button>;
}